// /src/locales/index.js

// Importe automatiquement tous les fichiers JSON du répertoire courant
const context = require.context('.', false, /\.json$/);

const translations = {};

// Mapping des codes de langue vers les noms complets de langue
export const languageNames = {
    en: 'English',
    //fr: 'Français',
    // ... ajoutez d'autres correspondances selon vos besoins
};

// Pour chaque fichier trouvé, ajoutez-le à l'objet translations
context.keys().forEach((key) => {
    // Retire './' et '.json' pour obtenir le code de la langue (par exemple 'en' pour './en.json')
    const langCode = key.replace('./', '').replace('.json', '');
    if (languageNames[langCode]) {
        translations[langCode] = {
            translation: context(key)
        };
    }
});

export const availableLanguages = Object.entries(languageNames).map(([code, name]) => ({
    code: code,
    name: name
}));

export default translations;
